// extracted by mini-css-extract-plugin
module.exports = {"section":"products-module--section--3dlY8","list":"products-module--list--2CIwS"};